<app-card-consulta (update)="update.emit($event)" [titulo]="titulo" [idConsulta]='idConsulta'
  [tipoConsulta]="tipoConsulta" [codigoControle]="codigoControle"
  [status]="status"
  [msg]="statusMsg"
  [token]="token">

  <ng-container *ngIf="consulta">

    <table class="table table-sm table-striped table-responsive-sm">
      <ng-container *ngFor="let c of consulta.lista; let i = index">
        <tr *ngIf="i==0">
          <th class="fw-500 text-center text-{{ !status || status=='info' ? 'primary' : status }}">
            Data Infração
          </th>
          <th class="fw-500 text-center text-{{ !status || status=='info' ? 'primary' : status }}">
            Data Vencimento
          </th>
          <th class="fw-500 text-center text-{{ !status || status=='info' ? 'primary' : status }}">
            Descrição
          </th>
          <th class="fw-500 text-center text-{{ !status || status=='info' ? 'primary' : status }}">
            Hora Infração
          </th>
          <th class="fw-500 text-center text-{{ !status || status=='info' ? 'primary' : status }}">
            Local
          </th>
          <th class="fw-500 text-center text-{{ !status || status=='info' ? 'primary' : status }}">
            Orgão
          </th>
          <th class="fw-500 text-center text-{{ !status || status=='info' ? 'primary' : status }}">
            Valor
          </th>
        </tr>
        <tr>
          <td class="text-center">{{c.dataInfracao}}</td>
          <td class="text-center">{{c.dataVencimento}}</td>
          <td class="text-center">{{c.descricao}}</td>
          <td class="text-center">{{c.horaInfracao}}</td>
          <td class="text-center">{{c.local}}</td>
          <td class="text-center">{{c.orgao}}</td>
          <td class="text-center">{{c.valor}}</td>
        </tr>
      </ng-container>
    </table>

  </ng-container>

</app-card-consulta>
